export default function NoData() {
    const divStyle = {
        textAlign: 'center'
    };

    return (
        <div className="row">
            <div className="col-12 col-lg-12" style={divStyle}>
                <img src="/dist/img/no-data.jpg" alt="User Avatar"
                     className="img-circle"/>
            </div>
            <div className="col-12 col-lg-12" style={divStyle}>
                <dt className="col-sm-12">NO DATA FOUND</dt>
            </div>
        </div>
    );
}